export default {
    BASE_URL: '/geetest',
    api: [
        {
            name: 'register',
            desc: '初始化极验',
            method: 'GET',
            path: 'startCaptcha'
        }
    ]
}



// WEBPACK FOOTER //
// ./src/api/pub/geetest.js